<template>
  <div>
    <div
      v-if="currentCoin"
      class="d-flex flex-column flex-sm-row align-sm-center justify-space-between"
    >
      <div class="d-flex align-center">
        <v-btn
          icon
          @click="toggleFavorite"
          class="current-market-card"
          v-if="isAuth"
        >
          <v-icon
            :class="[
              'favorite-icon',
              {
                'svg-color-secondary': currentCoin.isFavor
              }
            ]"
            class="me-2"
            style="cursor: pointer"
            size="12"
            >$favoriteStar
          </v-icon>
        </v-btn>
        <span class="font-Regular-20">{{ currentCoin.symbol }} </span>
      </div>
      <div
        class="text-white font-Regular-12 d-flex flex-column align-sm-center"
      >
        <span class="text-grey font-Bold-12 mb-2">{{
          $t("exchange.newPrice")
        }}</span>
        {{
          $thousandMask(currentCoin.close, currentCoin.frontBaseCoinScale, true)
        }}
      </div>
      <div class="d-flex flex-column align-sm-center">
        <span class="text-grey font-Bold-12 mb-2">{{
          $t("exchange.change")
        }}</span>
        <p
          class="mb-0"
          :class="
            currentCoin.chg >= 0
              ? currentCoin.chg === 0
                ? ''
                : 'green--text'
              : 'red--text'
          "
        >
          <span v-if="currentCoin.chg > 0">+</span>
          <span>{{ (currentCoin.chg * 100).toFixed(2) }}%</span>
        </p>
      </div>
      <div class="d-flex flex-column align-sm-center">
        <span class="text-grey font-Bold-12 mb-2">{{
          $t("exchange.high")
        }}</span>
        <div class="text-white font-Regular-12">
          {{ $thousandMask(currentCoin.high, currentCoin.frontBaseCoinScale) }}
        </div>
      </div>
      <div class="d-flex flex-column align-sm-center">
        <span class="text-grey font-Bold-12 mb-2">
          {{ $t("exchange.low") }}
        </span>
        <div class="text-white font-Regular-12">
          {{ $thousandMask(currentCoin.low, currentCoin.frontBaseCoinScale) }}
        </div>
      </div>
      <div
        class="d-flex flex-column align-sm-center"
        v-if="currentCoin.coinType !== 'VIRTUAL'"
      >
        <span class="text-grey font-Bold-12 mb-2">{{
          $t("exchange.exchangeNum")
        }}</span>
        <div class="text-white font-Regular-12">
          {{
            $thousandMask(
              currentCoin.twentyFourHourTurnover.toFixed(
                currentCoin.frontBaseCoinScale
              )
            )
          }}
          {{ currentCoin.symbol.split("/")[1] }}
        </div>
      </div>
      <div v-else>
        <div
          @click="coinTypeDescriptionModal = true"
          class="coin-type-box primary--text demotrading-btn"
        >
          {{ $t("exchange.demoMarket") }}
        </div>
      </div>

      <v-dialog v-model="coinTypeDescriptionModal" width="500">
        <v-card class="pa-4 gray10">
          <div class="modal-description" style="line-height: 1.8">
            {{ $t("exchange.modalText01") }}
          </div>
          <div class="mt-3 mb-3 modal-description" style="line-height: 1.8">
            {{ $t("exchange.modalText02") }}
          </div>
          <div class="modal-description" style="line-height: 1.8">
            {{ $t("exchange.modalText03") }}
          </div>
          <div class="text-left mt-5">
            <v-btn
              type="primary"
              @click="coinTypeDescriptionModal = false"
              color="primary"
            >
              {{ $t("common.getRealized") }}
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>{{ $t("common.nodata") }}</div>
  </div>
</template>
<script>
import $thousandMask from "@/mixins/thousandMask";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { ExchangeService } from "@/services";
import { authMixin } from "@/mixins/authMixin";

export default {
  name: "currentCard",
  mixins: [$thousandMask, authMixin],
  data() {
    return {
      coinTypeDescriptionModal: false
    };
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN
    })
  },
  methods: {
    ...mapActions({
      setCurrentCoin: types.marketExchange.actions.SET_CURRENT_COIN
    }),
    toggleFavorite() {
      let payload = {
        symbol: this.currentCoin.symbol
      };
      const api = !this.currentCoin.isFavor
        ? ExchangeService.addFavoredMarkets
        : ExchangeService.deleteFavoredMarkets;
      api(payload)
        .then(response => {
          if (response.data.code === 0) {
            this.$toast.success(
              !this.currentCoin.isFavor
                ? this.$t("exchange.do_favorite")
                : this.$t("exchange.cancel_favorite")
            );
            this.setCurrentCoin({
              ...this.currentCoin,
              isFavor: !this.currentCoin.isFavor
            });
          }
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    }
  }
};
</script>
<style scoped lang="scss">
.demotrading-btn {
  border: 1px solid #815bff;
  border-radius: 6px;
  cursor: pointer;
  padding: 10px;
}
</style>
